import { Button, Grid2, Typography } from '@mui/material'
import React from 'react'
import { Constants } from '../../shared/constants'
import "@fontsource/roboto-slab";
import { getImageUrl } from '../../shared/utils/getImageUrl';

const AddSection = ({ bgimg, title, subTitle, description, buttonText }) => {

    return (
        <Grid2 container sx={{
            borderRadius: "20px",
             pt: { xs: 5, lg: 10 },
            backgroundImage: `url(${getImageUrl(bgimg)})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
             height:"400px"
        }}

        >
            <Grid2 children size={{ xs: 12, md: 7 }} sx={{ display: "flex", flexDirection: "column", alignItems: "center", px: 2, pb: 2 }}>
                <Typography sx={{ fontSize: { xs: "35px", lg: "60px" }, fontWeight: 600, color: "primary.main", textAlign: "center", lineHeight: "100%", fontFamily: 'Roboto Slab' }}dangerouslySetInnerHTML={{__html:title}}/>
                
                
                


                <Typography sx={{ fontSize: { xs: "25px", lg: "35px" }, fontWeight: 300, color: "#136ECF", textAlign: "center", lineHeight: "100%", mt: 3, fontFamily: 'Roboto Slab' }}dangerouslySetInnerHTML={{__html:subTitle}}/>
                <Typography variant='body1' sx={{ fontWeight: 300, color: "#136ECF", textAlign: "center", width: "80%", my: 2, fontFamily: 'Roboto Slab' }} dangerouslySetInnerHTML={{__html:description}}/>

                <Button variant='outlined' style={{ borderRadius: "50px", border: "none", backgroundColor: "#fff", color: "#136ECF", width: "60%", fontFamily: 'Roboto Slab' }}   >{buttonText}</Button>
            </Grid2>
          </Grid2>
    )
}

export default AddSection